import { $api } from '@shared/api';
import { routes } from '@shared/api/routes';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

import { collectUiContext } from '../lib/collectUiContext';
import { AssistantMessage, KnowledgeAssistantResponse } from '../model/types';

interface SendKnowledgeAssistantMessageParams {
    question: string;
    history: AssistantMessage[];
    file?: File | null;
    signal?: AbortSignal;
}

export const sendKnowledgeAssistantMessage = async ({
    question,
    history,
    file,
    signal,
}: SendKnowledgeAssistantMessageParams): Promise<KnowledgeAssistantResponse> => {
    const requestData = {
        question,
        // Названия полей определены backend API.
        // eslint-disable-next-line camelcase
        page_path: window.location.pathname,
        // eslint-disable-next-line camelcase
        ui_context: collectUiContext(),
        history: history.slice(-6).map(({ role, content }) => ({ role, content })),
    };
    const body = file ? new FormData() : requestData;
    if (file && body instanceof FormData) {
        body.append('question', requestData.question);
        body.append('page_path', requestData.page_path);
        body.append('ui_context', JSON.stringify(requestData.ui_context));
        body.append('history', JSON.stringify(requestData.history));
        body.append('file', file);
    }

    const response = await $api.post<IDataResponse<KnowledgeAssistantResponse>>(
        routes.knowledgeAssistantMessage(),
        body,
        { signal }
    );

    if (response.data.status !== 'success' || !response.data.data) {
        throw new Error(response.data.message || 'Knowledge assistant request failed');
    }

    return response.data.data;
};
